/*
 * @Author: Chao Yang
 * @Date: 2019-12-11 09:51:08
 * @LastEditor: Chao Yang
 * @LastEditTime: 2019-12-11 10:14:23
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { format } from 'date-fns';
import { of } from 'rxjs';

@Injectable()
export abstract class BaseProxy {
  constructor(protected _http: HttpClient) {}

  getDateStr(date: Date) {
    if (date) {
      return format(date, 'yyyy/MM/dd');
    }
    return '';
  }

  getShadowUserDefaultObservable() {
    return of(null);
  }
}
